import { useTranslation } from 'react-i18next';
import PhoneInput from '../Utils/PhoneInput';

export const AdminInfo = ({ formData, onChange, onSubmit, onPrevious }) => {
    const { t } = useTranslation();
    return (
        <div className="w-full">
            <h2 className="text-2xl font-bold mb-4">{t('adminInfo.title')}</h2>
            <p className="mb-6 text-gray-600">{t('adminInfo.subtitle')}</p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                    <label className="block text-gray-700 mb-2">{t('absenceType.name')}</label>
                    <input
                        type="text"
                        placeholder={t('absenceType.name')}
                        value={formData.lastName}
                        onChange={(e) => onChange('lastName', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                        required
                    />
                </div>
                <div>
                    <label className="block text-gray-700 mb-2">{t('adminInfo.firstName')}</label>
                    <input
                        type="text"
                        placeholder={t('adminInfo.firstName')}
                        value={formData.firstName}
                        onChange={(e) => onChange('firstName', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                        required
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                    <label className="block text-gray-700 mb-2">Email</label>
                    <input
                        type="email"
                        placeholder="email"
                        value={formData.email}
                        onChange={(e) => onChange('email', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                        required
                    />
                </div>
                <div>
                    <label className="block text-gray-700 mb-2">{t('adminInfo.phone')}</label>
                    <PhoneInput
                        name="phone"
                        value={formData.phone}
                        onChange={(value) => onChange('phone', value)}
                        defaultCountry="SN"
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                    <label className="block text-gray-700 mb-2">{t('settingsPage.password')}</label>
                    <input
                        type="password"
                        placeholder="********"
                        value={formData.password}
                        onChange={(e) => onChange('password', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                        required
                    />
                </div>
                <div>
                    <label className="block text-gray-700 mb-2">{t('adminInfo.confirmPassword')}</label>
                    <input
                        type="password"
                        placeholder="********"
                        value={formData.confirmPassword}
                        onChange={(e) => onChange('confirmPassword', e.target.value)}
                        className="input input-bordered w-full px-4 py-2 rounded"
                        required
                    />
                </div>
            </div>

            <div className="mb-8">
                <label className="block text-gray-700 mb-2">{t('adminInfo.yourPosition')}</label>
                <select
                    value={formData.position}
                    onChange={(e) => onChange('position', e.target.value)}
                    className="input input-bordered w-full px-4 py-2 rounded"
                >
                    <option value="">{t('adminInfo.selectPosition')}</option>
                    <option value="PDG">PDG</option>
                    <option value="DRH">DRH</option>
                    <option value="DAF">DAF</option>
                    <option value="Comptable">{t('adminInfo.accountant')}</option>
                    <option value="Autre">{t('adminInfo.other')}</option>
                </select>
            </div>
        </div>
    );
};